import React, { useEffect, useState, useMemo } from "react";
import GroupAdminHeader from "../../../../../Comman/Header";
import GroupAdminSidebar from "../../../../../Comman/Sidebar";
import GroupAdminUperSide from "../../../../../Comman/UperSide";
import { connect } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import useDrawer from "../../../../../../context/DrawerContext";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import { useHistory, Link } from "react-router-dom";
import { UserPermissionAllData, userPermissionType } from "../../../../../Comman/UserPermission";
// import "./TableRes.css"
// import EmailTemplateCommon from "../EmailTemplateCommon/EmailTemplateCommon";
import TableFilter from "../../../../../NewTableCommon/tableFilter";
import ColumPopoverCommon from "../../../../../NewTableCommon/ColumPopoverCommon";
import useWindowHeight from "../../../../../NewTableCommon/useWindowsPosition";
import { branchfilterAndMapData } from "../../../../../Comman/BranchList";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { HeaderStyle } from "../../../OrderManagement/TableCommonModule";
import { tableOptionEmailTemplate, tableOptionPrinterList, tableOptionQRCode } from "../../../../../NewTableCommon/tableOption";
import { getBranchList, getEmailTemplateList } from "../../../../../../Store";
import Addnewdetails from "../../../../../Comman/AddNewDetails/Addnewdetails";
import { getQRCodeList } from "../../../../../../Store/actions/qrcode/qrcode-action";
import AddIcon from '@mui/icons-material/Add';
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ErrorMessage } from "../../../../../Comman/Error/ErrorMessage";
import api from "../../../../../../CommonApi/axios";
import { showSuccessNotification } from "../../../../../Comman/Swal/Swal";
import headers from "../../../../../../CommonApi/headers";
import Swal from "sweetalert2";

window.jquery = window.$ = $;



function QRCodeList({ getQRCodeList, qrCodeList }) {
      
      useEffect(() => {
            getQRCodeList()
      }, []);
      const userPermissionType_ = userPermissionType === "groupadmin"
      // const filteredOptions = branchfilterAndM     apData(BranchList_);
      const windowHeight = useWindowHeight();

      let history = useHistory();
      var pathname = window.location.pathname;
      var pathnamesplits = pathname.split("/");
      console.log(pathnamesplits,"......2")
      var url = pathnamesplits[3];
      const columnsDataString = sessionStorage.getItem(`${url}_columnData`);
      const columnsData = columnsDataString ? JSON.parse(columnsDataString) : null;
      const DisplayCol = columnsData && Object.values(columnsData).includes(false);
      const filterData = JSON.parse(sessionStorage.getItem(`${url}_filterData`));
      // const branchName = JSON.parse(sessionStorage.getItem(`${url}_branchName`));
      
      const [Id__, setId] = useState("");
      const [updateColumns, setUpdateColumns] = useState(false);
      const ColumnsDataString = sessionStorage.getItem(`${url}_columnData`);
      const dineInColumnsData = ColumnsDataString ? JSON.parse(ColumnsDataString) : null;

      const [show, setShow] = useState(false);
      const [error, setError] = useState(null);
      const [qrName, setqrName] = useState("");
      const [qrURL, setqrURL] = useState("");


      const handleClose = () => {
            // setError(null);
            setId("");
            setqrURL("")
            setqrName("")
            setError(null)
            setShow(false)
      }

      const handleEditQR = (Data) => {
            setqrName(Data?.qr_name);
            setqrURL(Data?.qr_link);
            setId(Data._id);
            handleShow();
      };

      // const handleDeleteQR = (Data) => {
      //       // setqrName(Data?.qr_name);
      //       // setqrURL(Data?.qr_link);
      //       setId(Data._id);
      //       handleShow();
      // };

      // const handleDownloadQR = (Data) => {
      //       // setqrName(Data?.qr_name);
      //       // setqrURL(Data?.qr_link);
      //       setId(Data._id);
      //       handleShow();
      // };

      const handleShow = () => setShow(true);
      
      // const [BranchId, setBranchID] = useState(branchName || "");


      // useEffect(() => {
      //       emailTemplateList();
      // }, [location]);

      // function emailTemplateList() {
      //       api
      //             .get(`/groupadmin/table_reservation_settings/email_template`, {
      //                   headers,
      //             })
      //             .then((res) => {
      //                   // const tableData = res?.data?.data?.charges?._id.includes(id);
      //                   const tableData = res?.data?.data
      //                   console.log("tableData" .tableData)
      //             });
      // }

      const [FilterData, SetFilterData] = useState("");
      const [filterAnchorEl, setFilterAnchorEl] = useState(null);
      const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);

      // const handleFilterClick = (event) => {
      //       setFilterAnchorEl(event.currentTarget);
      //       setIsFilterPopoverOpen(true);
      // };

      // const handleFilterClose = () => {
      //       setIsFilterPopoverOpen(false);
      // };

      // const handleApplyFilters = (filterData) => {
      //       setIsFilterPopoverOpen(false);
      //       SetFilterData(filterData)
      // };

      const [anchorEl_, setAnchorEl_] = useState(null);

      const handleClickColum_ = (event) => {
            setAnchorEl_(event.currentTarget);
      };
      const handleCloseColum_ = () => {
            setAnchorEl_(null);
      };

      const onColumnDataChange = () => {
            setUpdateColumns(prevState => !prevState);
      };

      function handleDeleteQR(Data) {
            // event.preventDefault();
            setError(null);

            Swal.fire({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, delete it!",
                }).then((result) => {   
                  if (result.isConfirmed) {         
                  $(".loader").show();
                  // item.append("reason", reason);
                  api
                        .delete(`/groupadmin/settings/qr_code/${Data._id}`, { headers })
                        .then((res) => {
                        $(".loader").hide();
                        getQRCodeList();
                        setqrURL("");
                        setqrName("");
                        setId(null)
                        showSuccessNotification("QR Code has been deleted succesfully.")
                        handleClose();
                        })
                        .catch((err) => {
                        $(".loader").hide();
                        if (err.response) {
                        setError(err.response?.data?.error?.message);
                        }
                        });
                  }
            })

      }

      function handleDownloadQR(Data) {
            // event.preventDefault();
            setError(null);
            console.log(Data,"......1")
            window.open(Data.qr_image)
            
            // else {
                  $(".loader").show();
                  // item.append("reason", reason);
                  // api
                  //       .get(`/groupadmin/settings/qr_code/${Data._id}`, { headers })
                  //       .then((res) => {
                  //       $(".loader").hide();
                  //       getQRCodeList();
                  //       setqrURL("");
                  //       setqrName("");
                  //       setId(null)
                  //       showSuccessNotification("QR Code has been deleted succesfully.")
                  //       handleClose();
                  //       })
                  //       .catch((err) => {
                  //       $(".loader").hide();
                  //       if (err.response) {
                  //       setError(err.response?.data?.error?.message);
                  //       }
                  //       });
            // }

      }

      function handleSubmitEdit(event) {
            event.preventDefault();
            setError(null);
            if (qrURL === "") {
                  setError("Please enter the URL");
                  return;
            }
            else {
                  $(".loader").show();
                  const bodyData = {qr_link:qrURL, name:qrName};
                  // item.append("reason", reason);
                  api
                        .post(`/groupadmin/settings/qr_code/${Id__}`, bodyData, { headers })
                        .then((res) => {
                        $(".loader").hide();
                        getQRCodeList();
                        setqrURL("");
                        setqrName("");
                        setId(null)
                        showSuccessNotification("QR Code has been edited succesfully.")
                        handleClose();
                        })
                        .catch((err) => {
                        $(".loader").hide();
                        if (err.response) {
                        setError(err.response?.data?.error?.message);
                        }
                        });
            }

      }

      function handleSubmit(event) {
          event.preventDefault();
          setError(null);
      
          if (qrName === "" || qrURL === "") {
            setError("Please enter the details.");
            return;
          }
          else {
            $(".loader").show();
      

            let bodyData = {
                  qr_name: qrName,
                  qr_link:qrURL,
            }
      
            api
              .post(`/groupadmin/settings/qr_code`, bodyData, { headers })
              .then((res) => {
                $(".loader").hide();
                getQRCodeList();
                showSuccessNotification("QR Code has been added succesfully.")
                handleClose();
              })
              .catch((err) => {
                $(".loader").hide();
                if (err.response) {
                  setError(err.response?.data?.error?.message);
                }
              });
          }
      
      }

      const VIEW = UserPermissionAllData?.role_details?.settings?.find(permission =>
            permission?.key === "qr_code")?.access?.includes("view")

      const DELETE = UserPermissionAllData?.role_details?.settings?.find(permission =>
            permission?.key === "qr_code")?.access?.includes("delete")

      const EDIT = UserPermissionAllData?.role_details?.settings?.find(permission =>
            permission?.key === "qr_code")?.access?.includes("edit")

      // const filteredMenuList = useMemo(() => {
      //       const status = FilterData?.Status?.value;
      //       // if (BranchId && BranchId.value !== "All" && status) {
      //       //       return emailTemplateList.filter(menu => menu.branch_id === BranchId.value &&
      //       //             menu.is_active === (status === "Active"));
      //       // } else if (BranchId && BranchId.value !== "All") {
      //       //       return emailTemplateList.filter(menu => menu.branch_id === BranchId.value);
      //       // } else if (status) {
      //       //       return emailTemplateList.filter(menu => menu.is_active === (status === "Active"));
      //       // }
      //       return qrCodeList;
      // }, [emailTemplateList, BranchId, FilterData?.Status?.value]);



      const Columns = useMemo(() => {
            const columns = [
                  {
                        accessorKey: '_id',
                        header: 'Sr.No',
                        size: 50,
                        Cell: ({ row }) => Number(row.index + 1),
                  },
                  {
                        accessorKey: 'qr_name',
                        header: 'QR Code Name',
                        size: 700,
                        Cell: ({ row }) => (row?.original?.qr_name),
                        // Cell: ({ row }) => {
                              // const hasViewPermission = userPermissionType_ || VIEW;
                              // return hasViewPermission ? (
                              //       <Link
                              //       // to={{
                              //       //       pathname: `/group_admin/settings/printer/printerDetails/${row?.original?._id}`,
                              //       // }}
                              //       >
                              //             <span style={HeaderStyle?.uniqueCodeHeader}>
                              //                   {row?.original?.template_name}
                              //             </span>
                              //       </Link>
                              // ) : (
                              //       <span style={HeaderStyle?.uniqueCodeHeader}>
                              //             {row?.original?.template_name}
                              //       </span>
                              // );
                        // },
                  },
                  {
                        accessorKey: 'qr_link',
                        header: 'QR URL',
                        size: 400,
                        Cell: ({ row }) => (row?.original?.qr_link || "---"),
                  },
            ];
            return dineInColumnsData === null ? columns : columns?.filter(column => dineInColumnsData[column?.header] === true);
      }, [updateColumns]);

      console.log(qrCodeList,".......1",url)
      const table = useMaterialReactTable({
            columns: Columns,
            data: qrCodeList,
            ...tableOptionQRCode({
                  getQRCodeList,
                  url,
                  handleClickColum_,
                  // handleSubmitActive,
                  // handleFilterClick,
                  windowHeight,
                  filterData,
                  DisplayCol,
                  DELETE, VIEW, EDIT, history,
                  handleEditQR,
                  handleDeleteQR,
                  handleDownloadQR
            }),
      });

      // console.log("filteredMenuList" ,filteredMenuList)

      const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();


      return (
            <React.Fragment>
                  <div
                        id="kt_body"
                        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
                  >
                        <div className="d-flex flex-column flex-root">
                              <div className="page d-flex flex-row flex-column-fluid">
                                    <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
                                    <div
                                          className="wrapper d-flex flex-column flex-row-fluid"
                                          id="kt_wrapper"
                                    >
                                          <GroupAdminHeader />
                                          <div

                                                className=" d-flex flex-column flex-column-fluid"
                                                id="kt_content"
                                          >
                                                <div id="kt_content_container" className="mx-7">
                                                      <main style={{ position: "initial", marginTop: "-27px" }} className={`main_ ${mainClassCustome.join(" ")}`}>
                                                            <div className="row ">
                                                                  <div className="col-md-6">
                                                                        <div
                                                                              className="d-flex justify-content-start"
                                                                              data-kt-docs-table-toolbar="base"
                                                                        >
                                                                              <h1 style={{ marginTop: "9px" }} className="anchor fw-bolder mb-5">
                                                                                    Settings - Custom QR Code
                                                                              </h1>

                                                                        </div>
                                                                  </div>
                                                                  <div
                                                                        className="col-md-6 text-end"
                                                                        data-kt-docs-table-toolbar="base"
                                                                  >
                                                                        <button
                                                                        className="btn btn-primary"
                                                                        onClick={() =>{
                                                                              setId('');
                                                                              handleShow();}
                                                                        }
                                                                        >
                                                                        Add QR Code
                                                                        </button>
                                                                  </div>
                                                                  
                                                            </div>
                                                            <hr style={{ opacity: 0.07, marginTop: 7 }} />
                                                            {/* <div className="row col-md-12 mb-4">
                                                                  <div
                                                                        className="col-md-9"
                                                                        data-kt-docs-table-toolbar="base"
                                                                  >
                                                                        <h3
                                                                              className="anchor fw-bolder mb-5 d-inline"
                                                                              id="custom-form-control"
                                                                        >
                                                                              Email Template
                                                                        </h3>
                                                                  </div>

                                                                  <div
                                                                        className="col-md-3 text-end"
                                                                        data-kt-docs-table-toolbar="base"
                                                                  >

                                                                  </div>
                                                            </div> */}

                                                            {/* <div className="rounded border p-5"> */}
                                                                  {/* <EmailTemplateCommon /> */}
                                                                  <div className="mt-8">
                                                                        <MaterialReactTable
                                                                              table={table}
                                                                        /></div>
                                                            {/* </div> */}
                                                      </main>
                                                </div>
                                          </div>
                                    </div>
                                    <GroupAdminUperSide />
                              </div>
                        </div>
                  </div>
                  <ColumPopoverCommon
                        anchorEl_={anchorEl_}
                        handleClickColum_={handleClickColum_}
                        onColumnDataChange={onColumnDataChange}
                        handleCloseColum_={handleCloseColum_}
                        url23={url}
                  />

                  <Modal show={show} onHide={handleClose}>
                        <Modal.Body>
                        <h1>{Id__ ? "Edit QR Code" : "Add QR Code"} </h1>
                        <Form onSubmit={Id__ ? handleSubmitEdit : handleSubmit}>
                        <Form.Group className="mb-3 mt-3" >
                              <Form.Label>Please enter an appropriate details.</Form.Label>
                              {/* <Form.Control
                              type="text"
                              placeholder="Enter reason"
                              value={reason}
                              onChange={(e) => setreason(e.target.value.replace(/^\s/, ''))}
                              /> */}
                        </Form.Group>
                        <Form.Group className="mb-3 mt-3" >
                              <Form.Label>QR Code Name <span style={{ color: "red" }}> *</span></Form.Label>
                              <Form.Control
                              type="text"
                              placeholder="Enter QR Code Name"
                              value={qrName}
                              onChange={(e) => setqrName(e.target.value.replace(/^\s/, ''))}
                              />
                        </Form.Group>
                        <Form.Group className="mb-3 mt-3" >
                              <Form.Label>QR URL <span style={{ color: "red" }}> *</span></Form.Label>
                              <Form.Control
                              type="text"
                              placeholder="E.g https://www.google.com"
                              value={qrURL}
                              onChange={(e) => setqrURL(e.target.value.replace(/^\s/, ''))}
                              />
                        </Form.Group>

            
                        <div className="col-md-12 text-center">
                              <br />
                              <div className="loader" style={{ display: "none" }}>
                              <img src="/assets/loader.gif" />
                              </div>
                        </div>
                        <ErrorMessage error={error} />
                        <Row className="text-center justify-content-center mx-1">
                              <Col lg={6} md={6} xs={6}>
                              <button type="submit" className="btn btn-primary w-100">
                              {Id__ ? "Edit" : "Save"}
                              </button>
                              </Col>
                              <Col lg={6} md={6} xs={6}>
                              <button
                                    type="button"
                                    onClick={handleClose}
                                    className="btn btn-danger w-100"
                              >     
                              Cancel
                              </button>
                              </Col>
                        </Row>
                        </Form>
                        </Modal.Body>
            
                  </Modal>

                  {/* <TableFilter
                        open={isFilterPopoverOpen}
                        anchorEl={filterAnchorEl}
                        handleClose={handleFilterClose}
                        handleFilter={handleApplyFilters}
                        url23={url}
                  /> */}

            </React.Fragment>
      );
}


const mapStateToProps = (state) => ({
      qrCodeList: state?.qrCodeList,
      // BranchList_: state.branchList,
});

const mapDispatchToProps = (dispatch) => {
      return {
            getQRCodeList: () => dispatch(getQRCodeList()),
            // getBranchList: () => dispatch(getBranchList()),
      };
};

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeList);

